/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Outcome_ReplacementInputs */

const en_claim_outcome_replacement = /** @type {(inputs: Claim_Outcome_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replacement`)
};

/**
* | output |
* | --- |
* | "Replacement" |
*
* @param {Claim_Outcome_ReplacementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_outcome_replacement = /** @type {((inputs?: Claim_Outcome_ReplacementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Outcome_ReplacementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_outcome_replacement(inputs)
});